// Sticky-pin voor hero-vacature footer bar.
// De bar pint vast onder het menu zodra zijn top de menu-bottom raakt, en
// releaset weer wanneer de bovenkant van het sollicitatieformulier de
// onderkant van de bar raakt. ScrollTrigger pin met pinSpacing:false zorgt
// dat het formulier niet wordt weggepusht door een placeholder.

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// ScrollTrigger registratie gebeurt al in @/js/lib/scroll.js; herhaling is
// idempotent maar veilig wanneer dit bestand los wordt geïmporteerd.
gsap.registerPlugin( ScrollTrigger );

const init = () => {
	const bar  = document.querySelector( '.o-heroVacature__footerBar' );
	const form = document.querySelector( '#solliciteer' );
	if ( ! bar || ! form ) {
		return;
	}

	// Header-hoogte = .p-header__bar (rem(83) ≈ 83px). Dynamisch lezen zodat
	// rem-aanpassingen / responsive height meebewegen.
	const headerEl = document.querySelector( '.p-header__bar' );

	const getHeaderH = () =>
		headerEl ? headerEl.getBoundingClientRect().height : 83;

	const getBarH = () => bar.getBoundingClientRect().height;

	ScrollTrigger.create( {
		trigger: bar,
		start: () => `top top+=${ getHeaderH() }`,
		endTrigger: form,
		end: () => `top top+=${ getHeaderH() + getBarH() }`,
		pin: true,
		pinType: 'transform',
		pinSpacing: false,
		invalidateOnRefresh: true,
	} );
};

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}

export {};
